/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ account: NonNullable<unknown> }} Integration_Connected_AsInputs */

const en_integration_connected_as = /** @type {(inputs: Integration_Connected_AsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Connected as ${i?.account}`)
};

const es_integration_connected_as = /** @type {(inputs: Integration_Connected_AsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Conectado como ${i?.account}`)
};

/**
* | output |
* | --- |
* | "Connected as {account}" |
*
* @param {Integration_Connected_AsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const integration_connected_as = /** @type {((inputs: Integration_Connected_AsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integration_Connected_AsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_integration_connected_as(inputs)
	return en_integration_connected_as(inputs)
});